import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { S } from '@/modules/ewerp/models/EnergiezahlerModels';

export type Getters = {
  maschinenLeistungsWerte(state: State): Array<S>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  maschinenLeistungsWerte(state) {
    return state.maschinenLeistungsWerte;
  },
};
